import React, {useMemo} from 'react'
import {AppBar, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import StageElement from './components/StageElement';
import GridBlock from 'components/GridBlock';
import {useParams, withRouter} from "react-router";
import RouterPath from "libs/RouterPath";
import Tr from "translations/Translations";
import {isDemandModification, isDemandOfferCollection, isDemandOfferEvaluation, isDemandPreparing, isDemandOfferDecryption} from "libs/getDemandStatus";
import {connect} from "react-redux";
import supportedNoApiScreens from "libs/supportedNoApiScreens";

const style = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        top: 64,
        zIndex: 1099
    },
    gridItem: {
        flexGrow: 1
    },
    modification: {
        fontWeight: 400
    }
})

function StageBar(
    {
        classes,
        location,
        demandHeader//ma się odświeżać na zmianę
    }) {

    const pathname = location.pathname;
    const demandId = useParams().id;

    const goSoStatus = useMemo(() => !!(demandHeader?.oldPlatformRoundStatusUrl) && supportedNoApiScreens(), [demandHeader]);


    const createElement = (label, label2, onClick, current) => ({label, label2, onClick, current})
    const rp = RouterPath.myProcedure;

    const stageClick = (path) => {
        if (goSoStatus) {
            window.location.href = demandHeader.oldPlatformRoundStatusUrl;
        } else {
            RouterPath.redirect(path);
        }
    }


    const elements = useMemo(() => {

        const preparing = !demandId || demandId <= 0 || isDemandPreparing();
        const modification = isDemandModification();
        const offerCollection = isDemandOfferCollection();
        const offerDecryption = isDemandOfferDecryption();
        const evaluation = isDemandOfferEvaluation();
        const exPost = demandHeader ? demandHeader.exPost : false;

        const elements = [
            createElement(
                Tr('mp_1'),
                modification ? Tr('modification') : undefined,
                () => {
                    stageClick(RouterPath.createPath(rp.steps.MP_1_ID, {id: demandId}))
                },
                pathname.startsWith(rp.steps.MP_1)),
            createElement(
                Tr('mp_2'),
                undefined,
                preparing || exPost ? undefined : () => {
                    stageClick(RouterPath.createPath(rp.steps.MP_2_ID, {id: demandId}))
                },
                pathname.startsWith(rp.steps.MP_2)),
            createElement(
                Tr('mp_3'),
                undefined,
                preparing || modification || offerCollection || offerDecryption || exPost ? undefined : () => {
                    stageClick(RouterPath.createPath(rp.steps.MP_3_ID, {id: demandId}))
                },
                pathname.startsWith(rp.steps.MP_3)),
            createElement(
                Tr('mp_4'),
                undefined,
                preparing || modification || offerCollection || offerDecryption || evaluation  ? undefined : () => {
                    stageClick(RouterPath.createPath(rp.steps.MP_4_ID, {id: demandId}))
                },
                pathname.startsWith(rp.steps.MP_4))
        ]
        return elements;
        // eslint-disable-next-line
    }, [demandHeader, demandId, pathname]);


    return (
        <AppBar
            id='stageBar'
            component='div'
            elevation={0}
            position='sticky'
            className={classes.root}
        >
            <GridBlock
                itemClassName={classes.gridItem}
            >
                {elements.map(({label, label2, onClick, current}, i) => {
                    return (
                        <StageElement
                            key={i}
                            current={current}
                            onClick={onClick}
                        >
                            {label} {!!label2 && <span className={classes.modification}>({label2})</span>}
                        </StageElement>
                    )
                })}
            </GridBlock>
        </AppBar>
    )
}

StageBar.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader
}), {})(withRouter(withStyles(style)(StageBar)));